import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import MaterialTable from 'material-table'
import { Edit, Close, Remove } from '@material-ui/icons'
import { Loader } from '../../default'
import { EditFilterModal, RemoveFilterModal } from '../../modal'
import { acSetFiltersModal, acGetAllFilters, acGetFilter } from '../../../class/actions'
import { dateFormat } from '../../../class/utils'
import { DB_CONST } from '../../../class/constants'

function TableFilter({
    currentFiltersModal, selectedFilter, filters
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(acGetAllFilters())
            .catch(err => console.error(err))
    }, [dispatch])

    const prepareColumns = () => {
        return [
            { title: t('modals.filters.manage.table.columns.id'), field: 'id', width: '2%' },
            { title: t('modals.filters.manage.table.columns.created_at'), field: 'created_at', width: '12%' },
            { title: t('modals.filters.manage.table.columns.name'), field: 'name', width: '20%' },
            { title: t('modals.filters.manage.table.columns.description'), field: 'description', width: '46%' },
            { title: t('modals.filters.manage.table.columns.event'), field: 'event', width: '20%' }
        ];
    }

    const prepareData = () => {
        if (!filters) {
            return []
        }

        return filters.slice(1).map(filter => {
            return {
                id: filter.filter_id,
                created_at: dateFormat(filter.createdAt),
                name: filter.name,
                description: filter.description,
                event: filter.rd_event_id ? filter.rdEvent.name : <Remove />
            }
        })

    }

    const editFilter = filterToBeEdited => {
        dispatch(acGetFilter(filterToBeEdited.id))
            .then(() => {
                dispatch(acSetFiltersModal(DB_CONST.FILTER_MODALS.EDIT))
            })
            .catch(err => console.error(err))
    }

    const removeFilter = filterToBeRemoved => {
        dispatch(acGetFilter(filterToBeRemoved.id))
        .then(() => {
            dispatch(acSetFiltersModal(DB_CONST.FILTER_MODALS.REMOVE))
        })
        .catch(err => console.error(err))
    }

    return (
        <>
            {
                selectedFilter && (
                    <>
                        <EditFilterModal
                            open={currentFiltersModal === DB_CONST.FILTER_MODALS.EDIT}
                            onClose={() => dispatch(acSetFiltersModal(null))}
                            filterToBeEdited={selectedFilter}
                        />

                        <RemoveFilterModal
                            open={currentFiltersModal === DB_CONST.FILTER_MODALS.REMOVE}
                            onClose={() => dispatch(acSetFiltersModal(null))}
                            filterToBeRemoved={selectedFilter}
                        />
                    </>
                )
            }
            {
                filters ? (
                    <MaterialTable
                        title={t('modals.filters.manage.title')}
                        columns={prepareColumns()}
                        data={prepareData()}
                        localization={t('materialTableLocale', { returnObjects: true })}
                        options={{
                            pageSize: 10
                        }}
                        actions={[
                            {
                                icon: () => (<Edit />),
                                tooltip: t('modals.filters.manage.table.options.edit'),
                                onClick: (_, rowData) => {
                                    editFilter(rowData)
                                }
                            },
                            {
                                icon: () => (<Close />),
                                tooltip: t('modals.filters.manage.table.options.close'),
                                onClick: (_, rowData) => {
                                    removeFilter(rowData)
                                }
                            }
                        ]}
                    />
                ) : <Loader />
            }
        </>
    )
}

TableFilter.propTypes = {
    filters: PropTypes.array,
}

TableFilter.defaultProps = {
    filters: []
}

const mapStateToProps = ({ ReducerFilter }) => ({
    currentFiltersModal: ReducerFilter.currentFiltersModal,
    selectedFilter: ReducerFilter.selectedFilter,
    filters: ReducerFilter.filters
})

export default connect(mapStateToProps)(TableFilter)